export enum CareProfileCategoryID {
  KeyInformation = 'key-information',
  Onboarding = 'onboarding',
  AttendanceAllowance = 'attendance-allowance',
  AttendanceAllowanceEligibility = 'aa-eligibility',
  CareAssessment = 'care-assessment',
  FinancialStatus = 'financial-status',
  EligibilityCalculator = 'eligibility-calculator',
  Consent = 'consent',
}

// Replica of the enums in api/store/seed.go
export enum MemberRole {
  PrimaryCaregiver = 'Primary Caregiver',
  CareRecipient = 'Care Recipient',
  AccountHolder = 'Account Holder',
  LegalRepresentative = 'Legal Representative',
  CareCircleMember = 'Care Circle Member',
  Employer = 'Employer',
  KareHeroExpert = 'KareHero Expert',
  KareHeroTechnician = 'KareHero Technician',
  ProfessionalCaregiver = 'Professional Caregiver',
}

/**
 * FieldType is the component type of a field.
 */
export enum FieldType {
  Text = 'text',
  TextArea = 'text-area',
  VerificationCode = 'verification-code',
  Password = 'password',
  Email = 'email',
  Number = 'number',
  Select = 'select',
  SelectCustom = 'select-custom',
  MultiSelect = 'multi-select',
  MultiSelectChip = 'multi-select-chip',
  MultiSelectBox = 'multi-select-box',
  MultiSelectCustom = 'multi-select-custom',
  RadioGroup = 'radio',
  Boolean = 'boolean',
  DatePicker = 'date',
  DateRange = 'date-range',
  Contact = 'contact',
  Address = 'address',
  Time = 'time',
  Slider = 'slider',
  SliderSelect = 'slider-select',
  SliderSeverity = 'slider-severity',
  BooleanTable = 'boolean-table',
  QuestionTable = 'question-table',
  CareCircleMemberSelector = 'care-circle-member-selector',
  TimePicker = 'time-picker',
  ToggleSelect = 'toggle-select',
  Switch = 'switch',
  InviteCode = 'invite-code',
  Consent = 'consent',
}
